import './services.tcat';
import './services.time_slot';
import { isDate, isEmpty, isUndefined } from 'lodash-es';
import dayjs from 'dayjs';

app.directive('timeSlotOptions', [
  '$filter',
  'timeSlotService',
  'tcatService',
  function ($filter, timeSlotService, tcatService) {
    const componentTemplate = `
      <div>
        <div class="form-group time-slots" ng-show="enabledTimeSlots">
          <div class="time-slots-title">{{"tcat.time_slot.title" | translate}}</div>
          <div class="select-cart-form">
            <select
              class="form-control"
              name="tcat.time_slot.title"
              ng-model="timeSlot"
              ng-change="onChange(timeSlot)"
              ng-required="isRequired()"
              ng-options="timeSlot as timeSlot.description disable when timeSlot.disabled for timeSlot in timeSlotOptions">
              <option value="" ng-if="showDefaultOption" >{{"dropdown.hint" | translate}}</option>
            </select>
          </div>
        </div>
        <input id="time_slot_key" type="hidden" name="order[delivery_data][time_slot_key]"/>
        <input id="delivery_time_slot_id" type="hidden" name="order[delivery_data][delivery_time_slot_id]"/>
        <input id="time_slot_group_key" type="hidden" name="order[delivery_data][time_slot_group_key]"/>
      </div>
    `;

    return {
      restrict: 'E',
      replace: true,
      template: componentTemplate,
      scope: {
        timeSlots: '=',
        timeSlotsTranslations: '=',
        deliveryOptionId: '=',
        deliveryOptionConfig: '=',
        deliveryTimeSlotRequired: '=',
        deliveryDate: '=',
        onTimeSlotChange: '&?',
        cartTagId: '=',
        regionType: '@',
      },
      link: function (scope, element) {
        scope.timeSlotOptions = [];
        scope.timeSlotId = '';
        scope.timeSlotKey = '';
        scope.timeSlotGroupKey = '';
        scope.isTimeSlotWithLimitedQuantity = false;

        scope.onChange = (item) => {
          if (isEmpty(item)) {
            element.find('#delivery_time_slot_id').val('');
            element.find('#time_slot_key').val('');
            element.find('#time_slot_group_key').val('');
            scope.onTimeSlotChange?.({
              value: {
                cartTagId: scope.cartTagId,
                delivery_time_slot_id: '',
                time_slot_key: '',
                time_slot_group_key: '',
              },
            });
            return;
          }

          if (scope.isTimeSlotWithLimitedQuantity) {
            element.find('#delivery_time_slot_id').val(item.key);
            element.find('#time_slot_key').val(item.description);
            element.find('#time_slot_group_key').val(item.groupKey);
            scope.onTimeSlotChange?.({
              value: {
                cartTagId: scope.cartTagId,
                delivery_time_slot_id: item.key,
                time_slot_key: item.description,
                time_slot_group_key: item.groupKey,
              },
            });
            return;
          }

          element.find('#time_slot_key').val(item.key);
          scope.onTimeSlotChange?.({
            value: {
              cartTagId: scope.cartTagId,
              time_slot_key: item.key,
            },
          });
        };

        function init() {
          scope.isTimeSlotWithLimitedQuantity =
            timeSlotService.isFeatureEnabled(scope.deliveryOptionConfig);

          scope.isTimeSlotWithLimitedQuantity
            ? initTimeSlotWithLimitedQuantity()
            : initTimeSlot();
        }

        function initTimeSlotWithLimitedQuantity() {
          scope.enabledTimeSlots =
            scope.deliveryOptionConfig.delivery_time_slot_enable &&
            timeSlotService.TIME_SLOT_ENABLED.includes(
              scope.deliveryOptionConfig.delivery_time_slot_type,
            );

          if (scope.enabledTimeSlots) {
            timeSlotService
              .getAvailableTimeSlots(scope.deliveryOptionId)
              .then(({ data }) => {
                scope.showDefaultOption = true;
                scope.timeSlotOptions = timeSlotService.getTimeSlotSelectItems(
                  data,
                  { ignoreAvailable: true },
                );
              });
          }

          initDatePickerWatcher();
        }

        function initTimeSlot() {
          let timeSlotOptions = [];
          let optionStructure = null;

          if (tcatService.isTcatHomeDeliveryType(scope.regionType)) {
            scope.enabledTimeSlots =
              scope.deliveryOptionConfig.tcat_time_slot_enable;
            timeSlotOptions = scope.timeSlots;
            optionStructure = function (item) {
              return {
                key: item.key,
                description: $filter('translate')(item.description),
              };
            };
          } else {
            scope.showDefaultOption = scope.enabledTimeSlots = !_.isEmpty(
              scope.timeSlotsTranslations,
            );
            timeSlotOptions = scope.timeSlotsTranslations;
            optionStructure = function (item) {
              return {
                key: $filter('translateModel')(item),
                description: $filter('translateModel')(item),
              };
            };
          }

          if (!scope.enabledTimeSlots) return;

          scope.timeSlotOptions = timeSlotOptions.map(optionStructure);
        }

        scope.isRequired = function () {
          return scope.isTimeSlotWithLimitedQuantity
            ? scope.deliveryTimeSlotRequired
            : true;
        };

        function handleDateTimeSlotItems(selectedDate) {
          const date = isDate(selectedDate)
            ? dayjs(selectedDate).format('YYYY-MM-DD')
            : undefined;

          timeSlotService
            .getAvailableTimeSlots(scope.deliveryOptionId, date)
            .then(({ data }) => {
              scope.timeSlotOptions = timeSlotService.getTimeSlotSelectItems(
                data,
                { ignoreAvailable: isUndefined(selectedDate) },
              );
            });
        }

        function handleDateSlotItems(selectedDate) {
          if (!isDate(selectedDate)) {
            element.find('#delivery_time_slot_id').val('');
            element.find('#time_slot_group_key').val('');
            return;
          }

          const date = dayjs(selectedDate).format('YYYY-MM-DD');

          timeSlotService
            .getAvailableTimeSlots(scope.deliveryOptionId, date)
            .then(({ data }) => {
              const [timeSlot] = data;

              element.find('#delivery_time_slot_id').val(timeSlot._id);
              element.find('#time_slot_group_key').val(timeSlot.group_key);

              scope.onTimeSlotChange?.({
                value: {
                  cartTagId: scope.cartTagId,
                  delivery_time_slot_id: timeSlot._id,
                  time_slot_group_key: timeSlot.group_key,
                },
              });
            });
        }

        function initDatePickerWatcher() {
          scope.$watch('deliveryDate', function (newValue, oldValue) {
            if (newValue === oldValue) {
              return;
            }

            switch (scope.deliveryOptionConfig.delivery_time_slot_type) {
              case 'date_time_slots':
                handleDateTimeSlotItems(newValue);
                return;
              case 'date':
                handleDateSlotItems(newValue);
                return;
              default:
                return;
            }
          });
        }

        init();
      },
    };
  },
]);
